module.exports = __webpack_public_path__ + "static/roshan-e3c15fc35923add051bc38750c26de7e.jpg";